export function stripHtml(html) {
  if (!html) return "";
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export function truncateWords(text, maxWords = 6) {
  if (!text || text === "-") return "-";
  const plainText = stripHtml(text);
  const words = plainText.trim().split(/\s+/);
  if (words.length <= maxWords) return plainText;
  return words.slice(0, maxWords).join(" ") + "...";
}

export function truncateChars(text, maxChars = 14) {
  if (!text || text === "-") return "-";
  if (text.length <= maxChars) return text;
  return text.slice(0, maxChars) + "...";
}
